import { render, staticRenderFns } from "./giftManage.vue?vue&type=template&id=abcec340&scoped=true"
import script from "./giftManage.vue?vue&type=script&lang=js"
export * from "./giftManage.vue?vue&type=script&lang=js"
import style0 from "./giftManage.vue?vue&type=style&index=0&id=abcec340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcec340",
  null
  
)

export default component.exports